import { compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './redux';
import storage from 'redux-persist/lib/storage';

import { persistStore, persistReducer } from 'redux-persist'


const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {

    const reduxLogger = createLogger({ predicate: (getState, action) => true });
    let middlewares = [thunk]

    if (process.env.REACT_APP_NODE_ENV !== "production") {
        middlewares = [...middlewares, reduxLogger];
    }



    let store = createStore(persistedReducer, undefined,
        compose(applyMiddleware(...middlewares)))
    let persistor = persistStore(store)
    return { store, persistor }
}